export default "__VITE_ASSET__4a013ced__"